module.exports = __webpack_public_path__ + "img/xk.18ab3e2e.svg";